import React, { useContext, useEffect } from 'react';
import cn from 'classnames';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { DomUtilsCtx } from '../../contexts/domUtils';
import BrandLogo from '../BrandLogo';
import AppActions from '../../actions/app';

function UFOHeader() {
    const getPropsFromState = (state) => {
        const { app } = state;
        const {
            brand, locale, footerLinks, getFooterLinks
        } = app;
        const defaultLogo = {
            image: '',
            link: '',
            text: '',
            altText: ''
        };
        return {
            brand,
            locale: locale.canonical,
            logo: footerLinks && footerLinks.logo ? footerLinks.logo : defaultLogo,
            getFooterLinks
        };
    };

    const {
        logo, getFooterLinks, brand, locale
    } = useSelector(getPropsFromState, shallowEqual);
    const {
        isTopOfPage
    } = useContext(DomUtilsCtx);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!brand || !locale) return;
        dispatch(AppActions.getFooterLinks(brand, locale));
    }, [dispatch, brand, locale]);
    return (
        <header
            className={cn(
                'navbar',
                {
                    'header-scroll-not-top': !isTopOfPage
                }
            )}
        >
            <div className="logo">
                <BrandLogo callStatus={getFooterLinks} logo={logo} />
            </div>
        </header>
    );
}

export default UFOHeader;
